/* SEOULBLU storefront interactions */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const SB = window.SB || {};

  const money = (cents) => {
    const fmt = SB.moneyFormat || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    const withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? Math.round(cents / 100).toString() : withCommas);
  };
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const header = $('[data-sb-header]');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();

  $$('[data-sb-search-open]').forEach((a) => a.addEventListener('click', (e) => {
    const box = $('[data-sb-search]'); if (!box) return;
    e.preventDefault(); box.hidden = !box.hidden; if (!box.hidden) $('input[type=search]', box).focus();
  }));

  let lastFocus = null;
  const open = (el) => { lastFocus = document.activeElement; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; const f = $('button, a, input', el.querySelector('[role=dialog], nav') || el); f && f.focus(); };
  const close = (el) => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; lastFocus && lastFocus.focus(); };
  const mnav = $('#sb-mnav'); const drawer = $('#sb-cart');
  $$('[data-sb-menu-open]').forEach((b) => b.addEventListener('click', () => { open(mnav); b.setAttribute('aria-expanded', 'true'); }));
  $$('[data-sb-menu-close]').forEach((b) => b.addEventListener('click', () => { close(mnav); $$('[data-sb-menu-open]').forEach((x) => x.setAttribute('aria-expanded', 'false')); }));
  $$('[data-sb-close]').forEach((b) => b.addEventListener('click', () => close(drawer)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { [mnav, drawer].forEach((p) => p && p.classList.contains('is-open') && close(p)); } });

  const itemsEl = $('[data-sb-cart-items]'); const footEl = $('[data-sb-cart-foot]');
  const errEl = $('[data-sb-cart-error]');
  const showErr = (msg) => { if (!errEl) return; errEl.textContent = msg; errEl.hidden = !msg; };

  const renderCart = (cart) => {
    $$('[data-sb-count]').forEach((c) => { c.textContent = cart.item_count; c.hidden = cart.item_count === 0; });
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = `<p class="sb-drawer__empty">Your bag is empty.</p><p style="text-align:center"><a class="sb-btn sb-btn--outline" href="/collections/all">Shop the Collection</a></p>`;
      footEl.hidden = true; return;
    }
    itemsEl.innerHTML = cart.items.map((it, i) => `
      <div class="sb-dline">
        <a href="${esc(it.url)}" class="sb-dline__img" ${it.image ? `style="background-image:url('${esc(it.image)}${it.image.includes('?') ? '&' : '?'}width=200')"` : ''} aria-label="${esc(it.product_title)}"></a>
        <div>
          <a href="${esc(it.url)}" class="sb-dline__title">${esc(it.product_title)}</a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<p class="sb-dline__price">${esc(it.variant_title)}</p>` : ''}
          <p class="sb-dline__price">${money(it.final_price)}</p>
          <div class="sb-qty">
            <button type="button" aria-label="Decrease quantity" data-line="${i + 1}" data-q="${it.quantity - 1}"><svg class="sb-ic" viewBox="0 0 24 24"><path d="M6 12h12"/></svg></button>
            <input type="number" value="${it.quantity}" min="0" aria-label="Quantity" data-line="${i + 1}">
            <button type="button" aria-label="Increase quantity" data-line="${i + 1}" data-q="${it.quantity + 1}"><svg class="sb-ic" viewBox="0 0 24 24"><path d="M6 12h12M12 6v12"/></svg></button>
          </div>
        </div>
        <div style="text-align:right">
          <p class="sb-dline__price">${money(it.final_line_price)}</p>
          <button type="button" class="sb-link sb-dline__remove" data-line="${i + 1}" data-q="0">Remove</button>
        </div>
      </div>`).join('');
    $('[data-sb-subtotal]').textContent = money(cart.total_price);
    footEl.hidden = false;
  };

  const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => { renderCart(c); return c; });

  const change = (line, quantity) => {
    showErr('');
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) })
      .then(async (r) => { const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || 'Could not update your bag.'); return d; })
      .then(renderCart).catch((e) => showErr(e.message));
  };

  itemsEl && itemsEl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line][data-q]'); if (!b) return;
    change(Number(b.dataset.line), Math.max(0, Number(b.dataset.q)));
  });
  itemsEl && itemsEl.addEventListener('change', (e) => {
    const i = e.target.closest('input[data-line]'); if (!i) return;
    change(Number(i.dataset.line), Math.max(0, parseInt(i.value, 10) || 0));
  });

  $$('[data-sb-cart-open]').forEach((a) => a.addEventListener('click', (e) => {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault(); fetchCart().finally(() => open(drawer));
  }));

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-sb-add], .sb-pdp__form'); if (!form) return;
    e.preventDefault();
    const btn = $('[type=submit]', form); btn && btn.classList.add('is-loading');
    const fErr = $('[data-sb-form-error]', form); if (fErr) fErr.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(async (r) => { const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || 'Could not add to bag.'); return d; })
      .then(() => fetchCart()).then(() => open(drawer))
      .catch((err) => { if (fErr) { fErr.textContent = err.message; fErr.hidden = false; } else { fetchCart().then(() => { open(drawer); showErr(err.message); }); } })
      .finally(() => btn && btn.classList.remove('is-loading'));
  });

  $$('[data-sb-qty]').forEach((b) => b.addEventListener('click', () => {
    const input = $('input[name=quantity]', b.closest('.sb-qty'));
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.sbQty));
  }));

  $$('[data-sb-thumb]').forEach((b) => b.addEventListener('click', () => {
    const main = $('.sb-pdp__main img'); if (main) { main.removeAttribute('srcset'); main.src = b.dataset.sbThumb; }
  }));

  $$('[data-sb-autosubmit]').forEach((s) => s.addEventListener('change', () => s.form.submit()));
  $$('.sb-filter input[type=checkbox]').forEach((c) => c.addEventListener('change', () => c.form.submit()));

  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
  $$('.sb-reveal').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
})();
